export const OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'store-management-overview',
};
export const PERFORMANCE_ROUTE = {
    title: 'Mini Appp Shop Performance',
    name: 'store-management-performance',
};
export const STORES_ROUTE = {
    title: 'Stores',
    name: 'store-management-stores',
};
export const CART_SETTINGS_ROUTE = {
    title: 'Checkout Settings',
    name: 'store-management-cart-settings',
};
export const CART_PROMOS_ROUTE = {
    title: 'Cart Promos',
    name: 'store-management-cart-promos',
};
export const CART_PROMOS_NEW_ROUTE = {
    title: 'Create Cart Promo',
    name: 'store-management-cart-promos-new',
};
export const CART_PROMOS_EDIT_ROUTE = {
    title: 'Edit Cart Promo',
    name: 'store-management-cart-promos-edit',
};
export const DELIVERY_AREAS_ROUTE = {
    title: 'Delivery Areas',
    name: 'store-management-delivery-areas',
};
export const DELIVERY_AREAS_NEW_ROUTE = {
    title: 'Create Delivery Area',
    name: 'store-management-delivery-areas-new',
};
export const DELIVERY_AREAS_EDIT_ROUTE = {
    title: 'Edit Delivery Area',
    name: 'store-management-delivery-areas-edit',
};
export const PROMOS_ROUTE = {
    title: 'Promo Codes',
    name: 'store-management-promo-codes',
};
export const PROMOS_NEW_ROUTE = {
    title: 'Create Promo Code',
    name: 'store-management-promo-codes-new',
};
export const PROMOS_EDIT_ROUTE = {
    title: 'Edit Promo Code',
    name: 'store-management-promo-codes-edit',
};
export const ORDERS_ROUTE = {
    title: 'Orders',
    name: 'store-management-orders',
};
export const CUSTOMER_SEGMENT_ROUTE = {
    title: 'Customer Segment',
    name: 'store-management-customer-segment',
};
export const BROADCAST_ROUTE = {
    title: 'Broadcast',
    name: 'store-management-broadcast',
};
